module.exports = __webpack_public_path__ + "img/loja-online-branco.a6b53e65.png";